
<template functional>
  <footer 
    :class="classes" 
    class="the-footer flex-wrap justify-between">
    <span
    >&copy; {{ new Date().getFullYear() }}
      <a 
        href="#!" 
        target="_blank" 
        rel="nofollow">Express POS</a>, All rights
        Reserved</span
        >
    <span class="md:flex hidden items-center">
      <span>Hand-crafted & Made with</span>
      <feather-icon
        icon="HeartIcon"
        svg-classes="stroke-current text-danger w-6 h-6"
        class="ml-2 mr-2"
      />
      <span
      >by
        <a 
          href="mailto:hello@cw.co.ke" 
          target="_blank" 
          rel="nofollow"
        >Cloud Wave Solutions</a
      ></span
      >
    </span>
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
  props: {
    classes: {
      type: String,
    },
  },
  inject: {
    components: {
      default: {},
    },
  },
};
</script>
